<template lang="html">
  <div tabindex="0" 
        @click="toggleDropdown()"
        v-click-outside="close"
        class="dropdown-select"
        :aria-label="'Search by ' + placeholderText"> {{placeholderText}}
        <span class="icon-right">
          <i class="fa fa-angle-down"></i>
        </span>

      <ul class="dropdown-menu search-list unstyled-list" v-if="isOpen">
        <li :class="{selected: isSelectedOption(option.slug) > -1}"
            v-bind:key="index"
            v-for="(option, index) in options">
            <a @mousedown.prevent="select(option)">
              {{option.name}}
            </a>
        </li>
      </ul>
    </div>
</template>

<script>
import Bus from "./Bus.js";

export default {
  name: "dropdown-select",

  props: {
    category: {
      type: String,
      required: true
    },

    options: {
      type: Array,
      default: function() {
        return [{ name: "", slug: "" }];
      }
    },

    selectMultiple: {
      type: Boolean,
      default: true
    },

    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      isOpen: false,
      selected: []
    };
  },

  mounted: function() {
    let vm = this;

    Bus.$on("option-deselect", function(option, category) {
      let i = vm.isSelectedOption(option.name);
      if (category == vm.category && i > -1) {
        vm.deselect(i);
      }
    });

    Bus.$on("option-sync", function(data) {
      if (data[vm.category]) {
        for (let i = 0; i < data[vm.category].length; i++) {
          if (vm.isSelectedOption(data[vm.category][i].name) < 0) {
            vm.selected.push(data[vm.category][i].name);
          }
        }
      }
    });
  },

  computed: {
    placeholderText: function() {
      if (this.showSelected) {
        if (this.selectMultiple && this.selected.length > 1) {
          return this.selected[0] + this.addtlSelectedText();
        } else if (this.selected.length) {
          return this.selected[0];
        }
      }

      //if !showSelected just show category name instead
      return "Select " + this.category;
    }
  },

  methods: {
    addtlSelectedText: function() {
      if (this.selected.length < 2) {
        return false;
      }

      return " +" + (this.selected.length - 1) + " More";
    },

    // select: function(option) {
    //   let i = this.isSelectedOption(option.slug);
    //
    //   if (i > -1) {
    //     this.deselect(i);
    //     Bus.$emit("option-deselect", option.slug, this.category);
    //   } else {
    //     if (this.selectMultiple) {
    //       this.selected.push(option["slug"]);
    //     } else {
    //       if (this.selected.length) {
    //         Bus.$emit("option-deselect", this.selected[0], this.category);
    //       }
    //       this.selected[0] = option.slug;
    //     }
    //     Bus.$emit("option-select", option.slug, this.category);
    //   }
    // },

    select: function(option) {
      let i = this.isSelectedOption(option.name);

      if (i > -1) {
        this.deselect(i);
        Bus.$emit("option-deselect", option, this.category);
      } else {
        this.selected.push(option["name"]);
        Bus.$emit("option-select", option, this.category);
      }
    },

    deselect: function(i) {
      this.selected.splice(i, 1);
    },

    isSelectedOption: function(name) {
      return this.selected.indexOf(name);
    },

    toggleDropdown: function() {
      this.isOpen = !this.isOpen;
    },

    close: function() {
      this.isOpen = false;
    }
  }
};
</script>

<style lang="css">
</style>
